import jwt_decode from "jwt-decode";
import httpClient from "../api/httpClient";
import LoginService from "@/api/services/LoginService";

export default {
  login({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      return httpClient
        .post("/auth/authenticate", userData)
        .then((response) => {
          var decoded = jwt_decode(response.data.id_token);
          window.sessionStorage.removeItem("BearerToken");
          window.sessionStorage.setItem("BearerToken", response.data.id_token);
          const token = response.data.id_token;
          const userdata = setUserData(decoded);
          localStorage.removeItem("loginOTPCd");

          httpClient.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.id_token;
          window.sessionStorage.setItem("BearerToken", response.data.id_token);

          commit("otp_auth_success", { token, userdata });
          return resolve(response);
        })
        .catch((error) => {
          return reject(new Error(error));
        });
    });
  },
  otpValidate({ commit, dispatch }, otpPassword) {
    return new Promise((resolve, reject) => {
      return httpClient
        .post("/otp/validate", otpPassword)
        .then((response) => {
          var decoded = jwt_decode(response.data.id_token);
          window.sessionStorage.removeItem("BearerToken");
          window.sessionStorage.setItem("BearerToken", response.data.id_token);
          httpClient.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.id_token;
          const token = response.data.id_token;
          const userdata = setUserData(decoded);
          const lastUnsuccessfulLogin = response.data.lastUnsuccessfulLogin;
          if(lastUnsuccessfulLogin !=null){
            lastUnsuccessfulLogin.tryCount = response.data.tryCount;
          }
          const approvalDialog = response.data.loginDialogScreen;
          const afterLoginPageList = response.data.afterLoginPageList;
          console.log("LOGIN ACTION lastUnsuccessfulLogin");
          console.log("RESPONSE");
          console.log(response.data);
          console.log("------lastUnsuccessfulLogin-------");
          console.log(lastUnsuccessfulLogin);
          commit("auth_success", { token, userdata, lastUnsuccessfulLogin,approvalDialog ,afterLoginPageList});
          resolve(response);
        })
        .catch((error) => {
          return reject(new Error(error));
        });
    });
  },
  refreshToken({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      return httpClient
        .post("/auth/refreshToken")
        .then((response) => {
          var decoded = jwt_decode(response.data.id_token);
          window.sessionStorage.removeItem("BearerToken");
          window.sessionStorage.setItem("BearerToken", response.data.id_token);
          httpClient.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.id_token;
          const token = response.data.id_token;
          const userdata = setUserData(decoded);
          commit("auth_success", { token, userdata });
          resolve(response);
        })
        .catch((error) => {
          return reject(new Error(error));
        });
    });
  },

  logout({ dispatch }, commit) {
    return new Promise((resolve, reject) => {
      LoginService.logout()
        .then((result) => {
          window.sessionStorage.removeItem("BearerToken");
          window.sessionStorage.removeItem("user");
          window.sessionStorage.removeItem("authStatus");
          window.sessionStorage.removeItem("correlationId");
          localStorage.removeItem("loginOTPCd");


          delete httpClient.defaults.headers.common["Authorization"];

          delete httpClient.defaults.headers.common["X-VKN"];
          delete httpClient.defaults.headers.common["X-CORR"];
          return resolve(result);
        })
        .catch((error) => {
          return reject(new Error(error));
        });
    });
  },
};

function setUserData(decoded) {
  return {
    displayName: decoded.fullName,
    identityNumber: decoded.sub,
    role: decoded.auth,
    iat: decoded.iat,
    exp: decoded.exp,
    companyList: decoded.companyList,
    imagePath: decoded.imagePath,
    tokenValidityInSeconds: decoded.tokenValidityInSeconds
  };
}
